const FALLBACK_MESSAGE = 'Something went wrong. Try again.';

// The message to show for a failed request: the server's `error` from a
// rejected jQuery request (responseJSON) or from a response that carries one.
export default function requestErrorMessage(failure) {
	if(typeof failure === 'string' && failure) {
		return failure;
	}
	const message = failure?.responseJSON?.error || failure?.error;
	return typeof message === 'string' && message ? message : FALLBACK_MESSAGE;
}
